export default "__VITE_ASSET__a1807145__"